import React, { useEffect, useState } from 'react'
import { motion, useMotionValue, useTransform } from 'framer-motion'
import { Button, Title } from 'components'
import { useNavigate } from 'react-router-dom'
import { useStateValue } from 'providers'

import styled from 'styled-components'
const Deck = styled.div`
  position: absolute;
  bottom: 10vw;
  left: 0;
  right: 0;
  min-height: 20rem;
  max-height: 20rem;
  width: 100%;
  max-width: 25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: flex-end;
  z-index: 9999;
`

const Swipeable = styled(motion.div)`
  ${({ theme: { colors, defaults }, url }) => `
  background: ${colors('chrome')};
    border-radius: ${defaults('radius')};
  color: ${colors('text')};
    padding: 2rem;
  position: absolute;
  pointer-events: auto;
  width: 90vw;
  left: 5vw;
  top: 0;
  min-height: 20rem;
  max-height: 20rem;
  max-width: 25rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  * {
    z-index: 99;
    pointer-events: none;
  }
  .interactive {
    pointer-events: auto;
  }
  .bgimage {
      background-image: url("https://storage.googleapis.com/pinmonkey-dash/assets/${url}/asset.webp");
      background-size: cover;
      background-position: center;
      opacity: 0.25;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
  }
    `}
`

export const Cards = ({ cardData = [] }) => {
  const [cards, setCards] = useState([...cardData].reverse())

  useEffect(() => {
    setCards([...cardData].reverse())
  }, [cardData])

  return (
    <Deck>
      {cards.map((card, i) => {
        return (
          <Card
            key={card.id}
            cards={cards}
            setCards={setCards}
            {...card}
            index={i}
          />
        )
      })}
    </Deck>
  )
}

const Card = ({ id, index, setCards, cards, ...card }) => {
  if (!cards) return null
  const navigate = useNavigate()
  const [{ session }] = useStateValue()
  const x = useMotionValue(0)

  const rotateRaw = useTransform(x, [-150, 150], [-18, 18])
  const opacity = useTransform(x, [-150, 0, 150], [0, 1, 0])
  const isFront = id === cards[cards.length - 1].id

  const rotate = useTransform(() => {
    const offset = isFront ? 0 : index % 2 ? 2 : -2
    return `${rotateRaw.get() + offset}deg`
  })

  const handleDragEnd = (ev, info) => {
    if (Math.abs(x.get()) > 75) {
      setCards((pv) => pv.filter((v) => v.id !== id))
    }
  }

  return (
    <Swipeable
      style={{
        x,
        opacity,
        rotate,
        transition: '0.125s transform',
        boxShadow: isFront
          ? '0 20px 25px -5px rgb(0 0 0 / 0.5), 0 8px 10px -6px rgb(0 0 0 / 0.5)'
          : undefined
      }}
      animate={{
        scale: isFront ? 1 : 0.98
      }}
      drag={isFront ? 'x' : false}
      dragConstraints={{
        left: 0,
        right: 0
      }}
      onDragEnd={handleDragEnd}
      url={card?.Location?.media?.[0]?.url}
    >
      <div className="bgimage" />
      <Title level="3">{card.Location.name}</Title>
      <Button
        className="interactive"
        onPress={() => navigate(`/places/${card.Location.slug}`)}
      >
        view more
      </Button>
      {!session.user && (
        <Button
          className="interactive"
          onPress={() => navigate('/beta/host', {
            state: { location_id: card.Location.id, name: card.Location.name }
          })}
        >
          claim space
        </Button>
      )}
    </Swipeable>
  )
}
